import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-manager',
  templateUrl: './campaign-manager.component.html',
  styleUrls: ['./campaign-manager.component.scss']
})
export class CampaignManagerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
